// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"3eb1f073","407":"af9468d3","430":"92958542","726":"de5c60ac"}[chunkId] + ".chunk.css";
};